export const finance = {
  description: "Invoice issuing, payments, expenses, and the cash ledger.",
  recordExpense: "Record expense",
  recordPayment: "Record payment",
  newInvoice: "New invoice",
  invoices: "Invoices",
  noInvoices: "No invoices",
  noInvoicesDesc: "Create an invoice to bill a customer.",
  payments: "Payments",
  unapplied: "Unapplied",
  noPayments: "No payments",
  noPaymentsDesc: "Record a customer payment.",
  selectInvoice: "Select an invoice to see lines, balance, and actions.",
  moneyIn: "Money in",
  moneyOut: "Money out",
  net: "Net",
  cashLedger: "Cash ledger",
  when: "When",
  direction: "Direction",
  noCashMovements: "No cash movements",
  noCashMovementsDesc: "Payments and expenses appear here.",
  expenseRecordedToast: "Expense recorded",
  recordExpenseTitle: "Record an expense",
  invoiceCreatedToast: "Invoice created",
  createInvoice: "Create invoice",
  addLine: "Add line",
  invoiceIssuedToast: "Invoice issued",
  paymentRecordedToast: "Payment recorded",
  recordPaymentTitle: "Record a payment",
  dueOn: "Due {date}",
  totalAmount: "{amount} total",
  outstanding: "Outstanding",
  issue: "Issue",
  recordFullPayment: "Record full payment",
  invoiceOptional: "Invoice (optional)",
  unappliedPayment: "Unapplied payment",
};
